

// Re-exporting types if necessary, or interacting with them. 
// For now, we just move the constants. 


export type PricingCurrency = 'GBP' | 'USD' | 'EUR' | 'AUD' | 'INR';

export const PricingTiers = {
    // MARKET: CONSUMER / MAINTENANCE
    life: {
        monthly: {
            GBP: 4.99,
            USD: 6.99,
            EUR: 5.99,
            AUD: 9.99,
            INR: 199
        },
        annual: {
            GBP: 47.99,
            USD: 67.99,
            EUR: 57.99,
            AUD: 97.99,
            INR: 1999
        },
        bestFor: 'Maintenance & Independence',
        features: [
            'Full App Access (Prompts, Diary, Strategies)',
            'Care Circle (Family & Friends only)',
            'Personal Progress Tracking'
        ],
        excludedFeatures: [
            'No Clinician Connection',
            'Neuro-education Library'
        ]
        // savingsPercent: Calculated dynamically
    },

    // MARKET: CONSUMER / REHAB
    active: {
        monthly: {
            GBP: 25.00,
            USD: 35.00,
            EUR: 29.00,
            AUD: 45.00,
            INR: 999
        },
        // Quarterly (~15% Discount) - Base price billed every 3 months
        quarterly: {
            GBP: 60.00,
            USD: 84.00,
            EUR: 69.60,
            AUD: 108.00,
            INR: 2399
        },
        // Annual (~35% Discount) - Base price billed every year
        annual: {
            GBP: 195.00,
            USD: 273.00,
            EUR: 226.00,
            AUD: 351.00,
            INR: 7799
        },
        bestFor: 'Active Rehabilitation',
        features: [
            'Everything in Life, plus:',
            'Connect to your Therapist (Share data & receive tasks)',
            'Neuro-Education Library',
            'Advanced Clinical Analytics',
            'Priority Support'
        ],
        excludedFeatures: []
        // savingsPercent: Calculated dynamically
    },

    // MARKET: CLINICAL / TEAMS (B2B)
    professional: {
        // Single Seat (Base £29.99)
        tierSingle: {
            count: '1',
            price: { GBP: 29.99, USD: 39.99, EUR: 34.99, AUD: 59.00, INR: 2999 }
        },
        // Small Team (Base £25.00)
        tier1: {
            count: '2-5',
            price: { GBP: 25.00, USD: 33.00, EUR: 29.00, AUD: 49.00, INR: 2499 }
        },
        // Clinic (Base £20.00)
        tier2: {
            count: '6-15',
            price: { GBP: 20.00, USD: 26.00, EUR: 23.00, AUD: 39.00, INR: 1999 }
        },
        // Enterprise / Large Dept (Base £15.99)
        tier3: {
            count: '16+',
            price: { GBP: 15.99, USD: 21.00, EUR: 18.50, AUD: 31.00, INR: 1599 }
        },
        clinicianFeatures: [
            `<b>Draft Now, Pay Later:</b> Build full rehab plans and resources before inviting a client or paying a penny.`,
            `<b>Unlimited Team Seats:</b> Invite collaborating OTs and MDT members for free.`,
            `<b>AI Therapy Builder:</b> Turn clinical notes into actionable strategies instantly`,
            `<b>Interactive Sandbox:</b> Test neumind safely with a pre-loaded demo environment`,]
    },

    // MARKET: LEGAL / INSURANCE (ONE-OFF)
    recoveryArc: {
        // Base £1,200 (Updated from CSV)
        price: {
            GBP: 1200,
            USD: 1600,
            EUR: 1400,
            AUD: 2400,
            INR: 125000 // No PPP (High value medical legal report)
        },
        // Integration Plan (Formerly Access) - £450
        integrationAddOn: {
            GBP: 450,
            USD: 600,
            EUR: 525,
            AUD: 900,
            INR: 45000
        },
        // Supported Setup - £150
        setupAddOn: {
            GBP: 150,
            USD: 200,
            EUR: 175,
            AUD: 300,
            INR: 15000
        },
        bestFor: 'For those wanting complete integration and support',
        features: [
            '12 Months Full Neumind Active Access',
            'Clinician & Family Seats Included',
            'Usage & Outcome Reports for Court',
            'Priority Onboarding Support'
        ]
    },

    enterprise: {
        bestFor: 'For large organisations & NHS',
        features: [
            'Volume Discounts',
            'SLA & Priority Support',
            'Custom Implementation',
            'Invoicing Options'
        ]
    }
} as const;


